import React, { useMemo } from "react";
import { RCCButton } from "react-common-components";
import DropdownWithBackground from "src/components/DropdownWithBackground";
import Title from "src/components/Title";

import { css } from "styled-components";
import { IButtonListOfIndicators } from "./interface";

const styledButtonExpandOrCompressGroupers = css`
	position: sticky;

    bottom: 1.5rem;
    z-index: 10;

	h3{
     transition: 200ms ease;
     &:hover{
        text-decoration: underline;
        cursor: pointer;
     }
  }
`;

const ButtonListOfIndicators: React.FC<IButtonListOfIndicators> = ({
	onClickList,
	data
}) => {
	const List = useMemo(() => data.map((dt, index) => <Title key={`listOfIndicators-for-presentation-grup${dt.iqc001Id}`} color="purple" size="sm" marginBottom={0} marginTop={2} onClick={() => onClickList(dt.iqc001Id)}>{index + 1}. {dt.iqc001Descricao}</Title>), [data]);
	return(
		<>

			<DropdownWithBackground
				position="topStart"
				callerComponent={
					<RCCButton
						icon={{name: "list" , color: "#FFF", size: 16}}
						color="grey"
						layout="isRounded"
						size="md"
						className="noPrintElement"
					/>
				}
				styleInline={styledButtonExpandOrCompressGroupers}
			>
				{List}
			</DropdownWithBackground>
			
		</>
	);};

export default ButtonListOfIndicators;
